import task from 'helpers/task'
import inject from 'helpers/inject'

import ApiService from 'services/api'

import getApiKeys from 'tasks/getApiKeys'

export default task(async function({ id, domains, blocked }) {
  const api = inject(ApiService)
  const key = await api.request({
    url: `/api/keys/${id}`,
    method: 'PATCH',
    data: { domains, blocked }
  })
  getApiKeys.result.forEach(apiKey => {
    if (apiKey.id === key.id) Object.assign(apiKey, key)
  })
  return key
}, {
  defaultValue: null
})



// WEBPACK FOOTER //
// ./src/tasks/updateApiKey.js